<template>
  <div class="myCollectionBox">
    <!-- 标题box -->
    <div class="myCollectionBox_title">{{ title }}</div>
    <!-- 主体box -->
    <div class="myCollectionBox_main">
      <!-- 顶部操作 -->
      <div class="mainBox_top">
        <el-checkbox
          v-model="selectedAll"
          style="width: 82px"
          @change="selectAll"
          >全选</el-checkbox
        >
        <el-link :underline="false" @click="deleteAll()">取消收藏</el-link>
      </div>
      <!-- 表头 -->
      <div class="mainBox_thead">
        <!-- <span style="width:360px">商品名称</span>
        <span style="width:151px">单位</span>
        <span style="width:151px">单价</span>
        <span style="width:206px">数量</span>
        <span style="width:206px">操作</span> -->
        <span style="width: 410px">商品名称</span>
        <span style="width: 200px">单位</span>
        <span style="width: 200px">单价</span>
        <span style="width: 264px">操作</span>
      </div>
      <!-- 收藏商品列表 -->
      <div
        class="mainBox_list"
        v-for="(item, index) in collectList"
        :key="index"
      >
        <div style="width: 410px; display: flex">
          <el-checkbox
            v-model="item.info.isSelected"
            style="width: 97px"
            @change="changeStatus()"
            ><img
              :src="item.info.thumb"
              alt=""
              style="width: 66px; height: 66px"
          /></el-checkbox>
          <div class="mainBox_listName">
            <div>{{ item.info.title }}</div>
            <!-- <span class="mainBox_listTag">麻辣</span> -->
          </div>
        </div>
        <div style="width: 200px">{{ item.info.unit }}</div>
        <div
          style="width: 200px; color: #ff4019; font-size: 14px"
          v-if="item.info.intervalPriceList"
        >
          ￥{{ item.info.intervalPriceList[0].price.toFixed(2) }}
        </div>

        <!-- <div class="mainBox_number">
          <div class="mainBox_numIpt">{{ item.info.num }}</div>
          <div class="mainBox_numBtnBox">
            <button
              class="mainBox_numAdd"
              style="transform: rotate(180deg);"
              @click="addNum(index)"
            >
              <i class="iconfont">&#xe624;</i>
            </button>
            <button class="mainBox_numAdd" @click="reduceNum(index)">
              <i class="iconfont">&#xe624;</i>
            </button>
          </div>
          <span>{{ item.info.unit }}</span>
        </div> -->
        <div class="addCarBtnBox">
          <el-button
            type="primary"
            class="addCarBtn"
            @click="addShopCar(item.info)"
            :disabled="item.info.status != 1"
            >加入购物车</el-button
          >
        </div>
      </div>
      <!-- 无数据时替代 -->
      <el-empty
        description="暂无数据"
        v-if="collectList.length == 0"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import { doGet, doPost } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      collectListArr: [],
      collectList: [], //收藏商品列表
      selectedAll: false, //是否全选
      shopCar: [], //购物车列表
    };
  },
  mounted() {
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCar = res.data;
              that.shopCar.forEach((item) => {
                item.info = JSON.parse(item.info);
              });
              var shopCarNum = 0;
              that.shopCar.forEach((x) => {
                shopCarNum += x.info.num; //计算购物车商品总数
              });
              that.$store.commit("saveShopCarNum", shopCarNum);
            } else {
              that.collectListArr = res.data;
              that.collectListArr.forEach((item) => {
                item.info = JSON.parse(item.info);
              });

              if (that.collectListArr.length > 0) {
                that.getNewPrice(); //更新收藏夹价格
              }
            }
          }
        },
        function (res) {}
      );
    },
    /**
     * 更新收藏夹中商品信息
     */
    getNewPrice() {
      for (var i = 0; i < this.collectListArr.length; i++) {
        this.getList(this.collectListArr[i].info.id, i);
      }
    },
    /**
     * 获取商品详情
     */
    getList(id, index) {
      var that = this;
      doGet(
        httpConfig.GoodsInfo.getDataUrl,
        { goodsId: id },
        function (res) {
          if (res.flag) {
            var goodData = res.data;

            goodData.isSelected = that.collectListArr[index].info.isSelected;
            that.collectListArr[index].info = goodData;

            if (index + 1 == that.collectListArr.length) {
              that.collectList = that.collectListArr;
              that.getSelected();
            }
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 判断是否被全选，计算选中的商品简述
     */
    getSelected() {
      this.selectedAll = true;
      this.collectList.forEach((item, index) => {
        if (item.info.isSelected == false) {
          this.selectedAll = false;
        }
      });
      if (this.collectList.length == 0) {
        this.selectedAll = false;
      }
    },
    /**
     * 勾选单件商品
     */
    changeStatus() {
      this.getSelected();
    },
    /**
     * 全选
     */
    selectAll() {
      var that = this;
      this.selectedAll = false;
      this.collectList.forEach((item) => {
        if (item.info.isSelected == false) {
          that.selectedAll = true;
        }
      });

      this.collectList.forEach((item) => {
        item.info.isSelected = this.selectedAll;
      });
    },
    /**
     * 取消收藏
     */
    deleteAll() {
      var that = this;
      if (this.collectList.some((x) => x.info.isSelected == true)) {
        this.$confirm("确认取消收藏选中商品？")
          .then((_) => {
            var arr = [];
            for (var i = 0; i < that.collectList.length; i++) {
              if (that.collectList[i].info.isSelected) {
                arr.push(that.collectList[i].id);
              }
            }

            doGet(
              httpConfig.shopCar.batchDeleteShopCarUrl,
              {
                ids: arr.join(","),
                type: 1,
              },
              function (res) {
                if (res.flag) {
                  for (var i = 0; i < that.collectList.length; i++) {
                    if (that.collectList[i].info.isSelected) {
                      that.collectList.splice(i, 1);
                      i--;
                    }
                  }

                  that.$store.commit("saveShopCarNum", that.collectList.length);

                  that.getSelected();
                  that.$message({
                    type: "success",
                    message: "取消收藏成功!",
                  });
                }
              },
              function (res) {}
            );
          })
          .catch((_) => {});
      } else {
        this.$message({
          type: "warning",
          message: "请先勾选商品",
        });
      }
    },
    /**
     * 加入购物车
     */
    addShopCar(item) {
      var that = this;
      if (this.$cookies.get("peopleId")) {
        var flag = false;
        that.shopCar.forEach((x) => {
          if (x.info.id == item.id) {
            flag = true;
          }
        });
        if (flag) {
          that.$message({
            type: "success",
            message: "已加入购物车",
          });
          return;
        }
        var data = {
          num: item.intervalPriceList[0].startNum,
          id: item.id,
          isSelected: true,
        };
        doGet(
          httpConfig.shopCar.saveShopCarUrl,
          {
            // id: that.shopId,
            info: JSON.stringify(data),
            type: 0,
          },
          function (res) {
            if (res.flag) {
              that.getShopCar(0);
              that.$message({
                type: "success",
                message: "加入购物车成功",
              });
            }
          },
          function (res) {}
        );
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/myCollection";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/myCollection.vue